import { ConfirmDialog } from "@/components/ui/confirm-dialog";

function RestrictReleaseGroupDialog({ open, onOpenChange, action, groupNumber, onConfirm, loading }) {
    const isRestrict = action === 'Restrict';

    const handleOpenChange = (nextOpen) => {
        if (!loading) {
            onOpenChange(nextOpen);
        }
    };

    return (
        <ConfirmDialog
            open={open}
            onOpenChange={handleOpenChange}
            title={isRestrict ? 'Restrict Group Number' : 'Release Group Number'}
            description={
                isRestrict
                    ? `Are you sure you want to restrict group number ${groupNumber}?`
                    : `Are you sure you want to release group number ${groupNumber}?`
            }
            onConfirm={onConfirm}
            onCancel={() => handleOpenChange(false)}
            confirmText="Yes"
            cancelText="No"
            variant="warning"
            confirmVariant="secondary"
            loading={loading}
            showIcon={true}
        />
    );
}

export default RestrictReleaseGroupDialog;
